var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"regional-comp-app"},[_c('div',{staticClass:"container my-3 mx-0 px-0"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('regional-comp')],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }